export const playData = [
    {
        "label": "日期",
        sortable: true,
        "value": '0,createTime'
    },
    {
        "label": "渠道",
        sortable: true,
        "value": '200,channel',
        render: (h,params)=>{
            return <div>
                {['facebook','tiktok','google'][params.row.channel]}
            </div>
        }
    },
    {
        "label": "短剧ID",
        nosum: true,
        width: 100,
        "value": '100,playId'
    },
    {
        "label": "短剧名称",
        width: 300,
        tooltip: true,
        "value": '120,playName'
    },
    {
        "label": "中文短剧名称",
        width: 300,
        tooltip: true,
        "value": '121,playCnName'
    },
    {
        "label": "语言",
        width: 100,
        tooltip: true,
        "value": '1,langName'
    },
    {
        "label": "投放金额",
        width: 120,
        sortable: true,
        "value": '2,cost'
    },
    {
        "label": "激活",
        "value": '3,activation'
    },
    {
        "label": "激活成本",
        "value": '4,activationCost',
        
    },
    {
        "label": "首日ROI",
        "value": '5,firstROI',
        needCalc: true,
        calc: {
            type: '/',
            unit: '%',
            data: ['firstRecharge','cost']
        },
        render:(h,params)=>{
            return <div>
                {params.row.firstROI?(Number(params.row.firstROI)*100).toFixed(2)+'%':0}
            </div>
        }
    },
    {
        "label": "3日ROI",
        "value": '6,thirdROI',
        needCalc: true,
        calc: {
            type: '/',
            unit: '%',
            data: ['thirdRecharge','cost']
        },
        render:(h,params)=>{
            return <div>
                {params.row.thirdROI?(Number(params.row.thirdROI)*100).toFixed(2)+'%':0}
            </div>
        }
    },
    {
        "label": "8日ROI",
        "value": '7,eighthROI',
        needCalc: true,
        calc: {
            type: '/',
            unit: '%',
            data: ['eighthRecharge','cost']
        },
        render:(h,params)=>{
            return <div>
                {params.row.eighthROI?(Number(params.row.eighthROI)*100).toFixed(2)+'%':0}
            </div>
        }
    },
    {
        "label": "15天ROI",
        "value": '8,fifthROI',
        needCalc: true,
        calc: {
            type: '/',
            unit: '%',
            data: ['fifthRecharge','cost']
        },
        render:(h,params)=>{
            return <div>
                {params.row.fifthROI?(Number(params.row.fifthROI)*100).toFixed(2)+'%':0}
            </div>
        }
    },
    {
        "label": "30天ROI",
        needCalc: true,
        calc: {
            type: '/',
            unit: '%',
            data: ['thirtyRecharge','cost']
        },
        "value": '9,thirtyROI',
        render:(h,params)=>{
            return <div>
                {params.row.thirtyROI?(Number(params.row.thirtyROI)*100).toFixed(2)+'%':0}
            </div>
        }
    },
    {
        "label": "60天ROI",
        needCalc: true,
        calc: {
            type: '/',
            unit: '%',
            data: ['sixtyRecharge','cost']
        },
        "value": '10,sixtyROI',
        render:(h,params)=>{
            return <div>
                {params.row.sixtyROI?(Number(params.row.sixtyROI)*100).toFixed(2)+'%':0}
            </div>
        }
    },
    // {
    //     "label": "累计ROI",
    //     needCalc: true,
    //     calc: {
    //         type: '/',
    //         unit: '%',
    //         data: ['allRecharge','cost']
    //     },
    //     "value": '11,totalROI',
    //     render:(h,params)=>{
    //         return <div>
    //             {params.row.totalROI?(Number(params.row.totalROI)*100).toFixed(2)+'%':0}
    //         </div>
    //     }
    // },
    {
        "label": "首日充值金额",
        "value": '12,firstRecharge'
    },
    {
        "label": "3日充值金额",
        "value": '13,thirdRecharge'
    },
    {
        "label": "8日充值金额",
        "value": '14,eighthRecharge'
    },
    {
        "label": "15日充值金额",
        "value": '15,fifthRecharge'
    },
    {
        "label": "30日充值金额",
        "value": '16,thirtyRecharge'
    },
    {
        "label": "60日充值金额",
        "value": '17,sixtyRecharge'
    },
    {
        "label": "3日增长倍数",
        "value": '19,threeTimesGrowth'
    },
    {
        "label": "8日增长倍数",
        "value": '20,eightTimesGrowth'
    },
    {
        "label": "15日增长倍数",
        "value": '21,fifthTimesGrowth'
    },
    {
        "label": "30日增长倍数",
        "value": '22,thirtyTimesGrowth'
    },
    {
        "label": "60日增长倍数",
        "value": '23,sixtyTimesGrowth'
    },
    // {
    //     "label": "累计增长倍数",
    //     needCalc: true,
    //     calc: {
    //         type: '/',
    //         data: ['allRecharge','firstRecharge']
    //     },
    //     "value": '24,allTimesGrowth'
    // },
]